import script from "./SelectService.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectService.vue?vue&type=script&setup=true&lang=js"

import "./SelectService.vue?vue&type=style&index=0&id=1ee8829a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee8829a"]])

export default __exports__